import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import MainForm from './mainForm'

const portletBreadcrumbs = [
  {
    name: 'Plantillas Generales',
    path: `/${CodigosTransaccionesConstant.PLANTILLASGENERALESCONTABILIDAD_LISTA}`
  },
  { name: 'Nuevo' }
]

const NuevoPage = () => {
  return (
    <Portlet>
      <Portlet.Header title='Plantillas Generales' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoPage)
